import React from 'react';
import ContactsForm from '../ContactsForm';
import useStyles from './styles';

interface IProps {
  title: string;
}

const ContactsWidget: React.FC<IProps> = (props) => {
  const { title } = props;
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.imageContainer}>
        <img
          className={classes.image}
          src="/img/root/contact.png"
          alt="Contact us"
        />
      </div>
      <div className={classes.container}>
        <div className={classes.form}>
          <p className={classes.titleLabel}>{title}</p>
          <ContactsForm />
        </div>
      </div>
    </div>
  );
};

export default ContactsWidget;
